<template>
    <div class="brt-tags">
        <span class="set" v-if="active>0">活动 {{ active}}</span>
        <template v-if="data.detail && data.detail.TAGS">
            <span v-for="(tag,index) in data.detail.TAGS">{{ tag.name }}</span>
        </template>
    </div>
</template>

<script>
    export default {
        name: "Tags",
        props: {
            'data': {
                default: () => Object
            }
        },

        data(){

            return {

            }
        },
        computed:{

            active(){

                let data = this.data;

                // console.log('data',data);

                //店铺活动只有一个
                if(data.activity && data.theme_activity){

                    return 1 + data.theme_activity.length;

                }else if(data.activity){

                    return 1

                }else if(data.theme_activity){

                    return data.theme_activity.length

                }else{
                    return 0
                }
            }
        }
    }
</script>

<style lang="less">
    @import "../../styles/comm.less";

    .brt-tags {
        position: relative;
        left: -@5px;

        &[scroll] {
            white-space: nowrap;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
        }

        > span {
            display: inline-block;
            height: @50px;
            line-height: @50px;
            border-radius: @5px;
            background-color: @fontColorB2;
            font-size: @normalFontSize - @2px;
            color: @fontColorB1;
            padding: 0 @10px;
            margin: @5px;

            &:nth-child(n+4) {
                background-color: @fontColorA4;
                color: @fontColorA3;
            }

            &.set {
                position: relative;
                padding: 0 @15px;
                background-color: @warningColor;
                color: #FFFFFF;

                @wh: @14px;
                &:before,
                &:after {
                    content: '';
                    display: inline-block;
                    width: @wh;
                    height: @wh;
                    border-radius: 50%;
                    background-color: #FFFFFF;
                    position: absolute;
                    top: 50%;
                    margin-top: -(@wh / 2);
                }

                &:before {
                    left: -(@wh / 1.8);
                }
                &:after {
                    right: -(@wh / 1.8);
                }
            }
        }
    }
</style>
